module.exports = {"140428100":"丹朱镇","140428101":"鲍店镇","140428102":"石哲镇","140428103":"大堡头镇","140428104":"慈林镇","140428105":"色头镇","140428106":"南漳镇","140428107":"宋村镇","140428108":"南陈镇","140428201":"碾张乡","140428202":"常张乡","140428400":"长子经济技术开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140428.json
// module id = 389
// module chunks = 0